export default __webpack_public_path__ + "static/media/anagram.db3e1542.png";